var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactlessPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7061",
    "data-name": "Rectangle 7061",
    width: 48,
    height: 48,
    transform: "translate(726 405)",
    fill: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contactless_payments",
    "data-name": "Contactless payments",
    transform: "translate(-726 -405)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28027",
    "data-name": "Group 28027",
    transform: "translate(737.539 411.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28024",
    "data-name": "Group 28024",
    transform: "translate(15.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31137",
    "data-name": "Path 31137",
    d: "M174.153,278.741l-2.391-2.391a21.576,21.576,0,0,0,0-30.478l2.391-2.392A24.961,24.961,0,0,1,174.153,278.741Z",
    transform: "translate(-171.762 -243.479)",
    fill: "#002c77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28025",
    "data-name": "Group 28025",
    transform: "translate(10.079 4.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31138",
    "data-name": "Path 31138",
    d: "M168.383,274.721l-2.682-2.682a14.268,14.268,0,0,0,0-20.157l2.682-2.682A18.068,18.068,0,0,1,168.383,274.721Z",
    transform: "translate(-165.7 -249.199)",
    fill: "#3d72fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28026",
    "data-name": "Group 28026",
    transform: "translate(0 10.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31139",
    "data-name": "Path 31139",
    d: "M161.106,255.679l-7.245,7.245,7.245,7.245A10.245,10.245,0,0,0,161.106,255.679Z",
    transform: "translate(-153.861 -255.679)",
    fill: "#ffb063"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactlessPayments);
export default __webpack_public_path__ + "static/media/contactless_payments.67b87c99750ff814f340d55d45059f9f.svg";
export { ForwardRef as ReactComponent };